import React from 'react';
import { SocialProof } from '@naf/quote';
import { Link } from 'react-router-dom';
import { SocialProofType } from '@appTypes/blockTypes';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { useResolveLink } from '@hooks/useResolveLink';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';

interface SocialProofSerializerProps {
  value: SocialProofType;
}
export const SocialProofBlock = ({
  value: { title, rating, totalRatings, tooltip, text, author, authorImage, internalLink, externalLink, linkText },
}: SocialProofSerializerProps) => {
  const { getProcessedImage } = useCloudinary();
  const { isInternal: isInternalRef } = useResolveLink(internalLink?.slug);
  const refUrl = useDocumentUrlWithNode(internalLink) || '';
  const renderLink = () => {
    if (internalLink && isInternalRef) {
      return <Link to={refUrl}>{linkText}</Link>;
    }
    return (
      <a href={externalLink?.href} target={externalLink?.blank ? '_blank' : '_self'} rel="noopener noreferrer">
        {linkText}
      </a>
    );
  };
  return (
    <SocialProof
      title={title}
      rating={rating}
      totalNumberOfRatings={totalRatings}
      tooltip={tooltip}
      caption={author}
      img={
        authorImage
          ? {
              alt: authorImage?.altText || 'forfatterbilde',
              src: getProcessedImage(authorImage?.publicId || authorImage?.public_id, { width: 80 })?.toURL(),
            }
          : undefined
      }
      linkComponent={renderLink()}
    >
      {text}
    </SocialProof>
  );
};
export default SocialProofBlock;
